import { useCart } from '../context/CartContext';
import { useTranslation } from 'react-i18next';

const NoOnlinePurchaseModal = () => {
  const { isModalOpen, closeModal } = useCart();
  const { t } = useTranslation();

  if (!isModalOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <h2 className="text-2xl font-bold mb-4">{t('cart.noOnlinePurchase')}</h2>
        <p className="mb-6">{t('cart.contactToComplete')}</p>
        <button
          className="bg-black text-white px-8 py-3 rounded-lg font-bold hover:bg-gray-800 transition"
          onClick={closeModal}
        >
          {t('cart.understood')}
        </button>
      </div>
    </div>
  );
};

export default NoOnlinePurchaseModal; 